"use client";

import { cn } from "@/lib/utils";
import { memo } from "react";
import { ProcessCardsProps } from "./types";
import ProcessCard from "../ProcessCard";

const ProcessCards = ({ className, cards }: ProcessCardsProps) => {
  return (
    <div
      className={cn(
        "grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-6 justify-items-center",
        className
      )}
    >
      {cards?.map(({title, description }, i) => {
        return (
          <ProcessCard
            key={i}
            index={i + 1}
            title={title}
            description={description}
          />
        );
      })}
    </div>
  );
};

export default memo(ProcessCards);
